<template>
  <b-navbar toggleable="lg" type="light" class="shadow-sm jinro-nav">
    <b-container fluid class="layout-wide">
      <b-navbar-brand href="/" class="font-weight-bold jinro-logo">
        <span style="color: #00A1E1;">HAIM</span>,CHOI
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/Yacht" active-class="active">요트다이스</b-nav-item>
          <b-nav-item to="/HellishCommute" active-class="active">지옥의 퇴근길</b-nav-item>
          <template v-if="isLoggedIn">
            <b-nav-item v-if="userGroupType === 'admin'" to="/register" active-class="active">회원등록</b-nav-item>
            <b-nav-item to="/mypage" active-class="active">마이페이지</b-nav-item>
            <b-nav-item @click="handleLogout" class="text-danger logout-btn">로그아웃</b-nav-item>
          </template>

          <template v-else>
            <b-nav-item to="/login" active-class="active">로그인</b-nav-item>
<!--            <b-nav-item to="/Yacht" active-class="active">요트다이스</b-nav-item>-->
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HaimNavbar',
  data() {
    return {
      isLoggedIn: !!localStorage.getItem('token'),
      userGroupType: ''
    };
  },
  created() {
    this.updateAuthStatus();
  },
  watch: {
    '$route'() {
      this.updateAuthStatus();
    }
  },
  methods: {
    updateAuthStatus() {
      this.isLoggedIn = !!localStorage.getItem('token');
      const userGroupType = localStorage.getItem('userGroupType');
      this.userGroupType = userGroupType ? userGroupType : '';
    },
    handleLogout() {
      if (confirm('로그아웃 하시겠습니까?')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common['Authorization'];
        location.href = '/login';
      }
    }
  }
}
</script>

<style>
/* 1. 네비게이션 링크 기본 스타일 */
.jinro-nav .navbar-nav .nav-item .nav-link {
  font-weight: 500;
  color: #555 !important;
  margin: 0 8px;
  position: relative; /* 언더바 위치 기준 */
  padding-bottom: 5px;
  transition: color 0.3s ease;
}

/* 2. 언더바 (가상 요소) 기본 설정 - 숨김 상태 */
.jinro-nav .navbar-nav .nav-item .nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #00A1E1; /* 진로 블루 */
  transform: scaleX(0); /* 숨김 */
  transform-origin: bottom center;
  transition: transform 0.3s ease;
}

/* 3. [활성화 상태] 글자색 변경 */
/* BootstrapVue + Vue Router가 활성화되면
   .router-link-active 또는 .active 클래스가 붙습니다.
   이 두 가지를 모두 체크하도록 선택자를 강력하게 지정합니다.
*/
.jinro-nav .navbar-nav .nav-item .nav-link:hover,
.jinro-nav .navbar-nav .nav-item.active .nav-link,
.jinro-nav .navbar-nav .nav-item .nav-link.active,
.jinro-nav .navbar-nav .nav-item .nav-link.router-link-active {
  color: #00A1E1 !important;
  font-weight: 700;
}

/* 4. [활성화 상태] 언더바 나타나기 */
.jinro-nav .navbar-nav .nav-item.active .nav-link::after,
.jinro-nav .navbar-nav .nav-item .nav-link.active::after,
.jinro-nav .navbar-nav .nav-item .nav-link.router-link-active::after {
  transform: scaleX(1); /* 보이기 */
}

/* 5. 드롭다운 메뉴 아이템 활성화 */
.jinro-nav .dropdown-item.active,
.jinro-nav .dropdown-item:active {
  background-color: transparent !important;
  color: #00A1E1 !important;
  font-weight: 700;
}

/* 6. 로그아웃 버튼 예외 처리 (언더바 제거) */
.jinro-nav .logout-btn .nav-link {
  color: #ff4d4f !important;
}
.jinro-nav .logout-btn .nav-link::after {
  display: none !important;
}
</style>
